export default __webpack_public_path__ + "static/media/moola.175d7476.svg";